import {
	INIT_DATA,
	ADD_LESSON,
	ADD_TOPIC,
	ADD_QUIZ,
	ADD_QUESTION,
	UPDATE_NODE_TITLE,
} from '~/constants';

/**
 * Inits raw data
 *
 * @param {*} payload
 */
export const initData = ( payload ) => {
	return {
		type: INIT_DATA,
		payload,
	};
};

/**
 * Add a new lesson to raw data
 *
 * @param {*} payload
 */
export const addLesson = ( payload ) => {
	return {
		type: ADD_LESSON,
		payload,
	};
};

/**
 * Add a new topic to raw data
 *
 * @param {*} payload
 */
export const addTopic = ( payload ) => {
	return {
		type: ADD_TOPIC,
		payload,
	};
};

/**
 * Add a new quiz to raw data
 *
 * @param {*} payload
 */
export const addQuiz = ( payload ) => {
	return {
		type: ADD_QUIZ,
		payload,
	};
};

/**
 * Add a new question to raw data
 *
 * @param {*} payload
 */
export const addQuestion = ( payload ) => {
	return {
		type: ADD_QUESTION,
		payload,
	};
};

/**
 * Updates the node title in raw data
 *
 * @param {*} payload
 */
export const updateNodeTitle = ( payload ) => {
	return {
		type: UPDATE_NODE_TITLE,
		payload,
	};
};
